import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, isRef as _isRef, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5f37ac56"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "control has-icons-left" };
const _hoisted_2 = ["placeholder"];
const _hoisted_3 = { class: "icon is-small is-left" };
const _hoisted_4 = {
    key: 0,
    class: "list"
};
const _hoisted_5 = ["onClick"];
import { ref, computed } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'TypeAhead',
    props: {
        propData: {},
        placeholder: {},
        icon: {},
        labelField: {}
    },
    emits: ["itemSelected"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const getLabel = (item) => {
            return props.labelField ? item[props.labelField] : item.name;
        };
        let searchTerm = ref('');
        const searchResults = computed(() => {
            if (searchTerm.value === '') {
                return [];
            }
            let matches = 0;
            return props.propData.filter(item => {
                if (getLabel(item).toLowerCase().includes(searchTerm.value.toLowerCase()) && matches < 10) {
                    matches++;
                    return item;
                }
            });
        });
        const selectItem = (item) => {
            console.log(typeAheadInputElem.value);
            searchTerm.value = '';
            emit('itemSelected', item);
        };
        const typeAheadInputElem = ref(null);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("p", _hoisted_1, [
                    _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "search",
                        ref_key: "typeAheadInputElem",
                        ref: typeAheadInputElem,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (_isRef(searchTerm) ? (searchTerm).value = $event : searchTerm = $event)),
                        placeholder: _ctx.placeholder,
                        class: "input"
                    }, null, 8, _hoisted_2), [
                        [_vModelText, _unref(searchTerm)]
                    ]),
                    _createElementVNode("span", _hoisted_3, [
                        _createElementVNode("i", {
                            class: _normalizeClass(_ctx.icon)
                        }, null, 2)
                    ])
                ]),
                (searchResults.value.length)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchResults.value, (item) => {
                            return (_openBlock(), _createElementBlock("li", {
                                key: item.name,
                                onClick: ($event) => (selectItem(item)),
                                class: "list-item"
                            }, _toDisplayString(getLabel(item)), 9, _hoisted_5));
                        }), 128))
                    ]))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
